import omit from 'lodash/omit';

import {
    ADDRESS_REGIONS_LOAD_START,
    ADDRESS_REGIONS_LOAD_COMPLETE,
    ADDRESS_COUNTRIES_LOAD_START,
    ADDRESS_COUNTRIES_LOAD_COMPLETE,
} from '../actions/address';

const regionsLoadStart = (state) => ({
    ...state,

    regionsByCountry: {
        isLoading: true,
    },
});

const regionsLoadComplete = (state, action) => {
    if (!action.error) {
        return {
            ...state,

            regionsByCountry: {
                isLoading: false,
                content: action.payload.response.regions,
            },
        };
    }

    return omit(state, 'regionsByCountry');
};

const countriesLoadStart = (state) => ({
    ...state,

    countries: {
        isLoading: true,
    },
});

const countriesLoadComplete = (state, action) => {
    if (!action.error) {
        return {
            ...state,

            countries: {
                content: action.payload.response.countries,
                isLoading: false,
            },
        };
    }

    return omit(state, 'countries');
};

const ACTION_MAP = {
    [ADDRESS_REGIONS_LOAD_START]: regionsLoadStart,
    [ADDRESS_REGIONS_LOAD_COMPLETE]: regionsLoadComplete,
    [ADDRESS_COUNTRIES_LOAD_START]: countriesLoadStart,
    [ADDRESS_COUNTRIES_LOAD_COMPLETE]: countriesLoadComplete,
};

const addressReducer = (state = {}, action) => {
    const reducer = ACTION_MAP[action.type];

    if (reducer) {
        return reducer(state, action);
    }
    return state;
};

export default addressReducer;
